import React from "react";
import { Bar } from "@ant-design/plots";
import { useSelector } from "react-redux";
import "./index.css";

const DashboardAreasChart = () => {
  const { areasTurnOver } = useSelector((state) => state.areasReducer);

  const data = [];
  for (let i = 0; i < areasTurnOver?.length; i++) {
    const value = parseFloat(areasTurnOver[i].total.toFixed(2));

    if (value !== 0) {
      data.push({
        type: areasTurnOver[i].name,
        value,
      });
    }
  }

  const config = {
    data,
    xField: "value",
    yField: "type",
    seriesField: "type",
    legend: false,
    xAxis: {
      grid: null,
      label: null,
    },

    // height: data.length <= 4 ? data.length * 75 : 50,
    height: data.length * 50,
    label: {
      position: (percent) => {
        const totalSum = data.reduce((acc, cur) => acc + cur.value, 0);
        const individualPercentage = (percent.value / totalSum) * 100;
        return individualPercentage < 5 ? "right" : "middle";
      },
      content: (item) => {
        return item.value.toFixed(2);
      },
    },
    color: [
      "#003f5c",
      "#2f4b7c",
      "#665191",
      "#a05195",
      "#d45087",
      "#f95d6a",
      "#ff7c43",
      "#ffa600",
    ],
  };

  const isMobile = window.innerWidth < 850;
  if (isMobile) {
    config.height = data.length * 50;
  }

  return (
    <div className="areas-chart-main-container">
      <Bar {...config} className="areas-chart-secondary-container" />
    </div>
  );
};

export default DashboardAreasChart;
